//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faSparkle } from '@fortawesome/pro-solid-svg-icons';
import AiToolsMixin from '@motionelements/core/src/components/mixins/ai-tools.mixin.js';
import studioAiLinkMixin from '@/components/mixins/studioAiLink.mixin.js';

export default {
  name: 'StudioAi',
  mixins: [AiToolsMixin, studioAiLinkMixin],
  components: {
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
  },
  data() {
    return {
      faSparkle,
    };
  },
  computed: {
    pageTitle() {
      return this.$t('header.studio_ai');
    },
    pageDescription() {
      return this.$t('studio_ai.subheading');
    },
    comingSoonAiToolsText() {
      return this.comingSoonAiTools.map(({ title }) => title).join(', ');
    },
  },
};
